import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { SeparatorBlock, SeparatorBlockProps, SeparatorSpacing } from "./types";
import { useTranslation } from "react-i18next";


export default function EmailPanelVerticalSpacing() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext<SeparatorBlockProps>();
  const value = blockProps.block.properties?.spacing || "default";

  const handleUpdate = (spacing: SeparatorSpacing) => {
    blockProps.formAPI.updateField<SeparatorBlock>(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        spacing,
      },
    });
  };

  return (
    <PanelInlineContent title={t("editorBlocksLibrary.blocks.separator.panel.spacing.title", "Spacing")}>
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={value}
        onValueChange={handleUpdate}
      >
        <ToggleGroupItem value="small" aria-label="Toggle small spacing" className="text-xs">
          {t("editorBlocksLibrary.blocks.separator.panel.spacing.small", "Petit")}
        </ToggleGroupItem>
        <ToggleGroupItem value="default" aria-label="Toggle normal spacing" className="text-xs">
          {t("editorBlocksLibrary.blocks.separator.panel.spacing.default", "Normal")}
        </ToggleGroupItem>
        <ToggleGroupItem value="large" aria-label="Toggle large spacing" className="text-xs">
          {t("editorBlocksLibrary.blocks.separator.panel.spacing.large", "Large")}
        </ToggleGroupItem>
      </ToggleGroup>
    </PanelInlineContent>
  );
}
